import React from "react";
import {render} from "react-dom";
import "url-search-params-polyfill";
import App from "./App";

render(<App />, document.getElementById("container"));
